// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TerceraToolStripTemplate } from "../../templates.js";
import { ContainerControl } from "./ContainerControl.js";
import { TerceraButton } from "./TerceraButton.js";
import { TerceraButtonsPopup } from "./TerceraButtonsPopup.js";
import { TerceraSeparator } from "./TerceraSeparator.js";

export let TerceraToolStrip = ContainerControl.extend({
    template: TerceraToolStripTemplate,
    data: function ()
    {
        return {
            toolStipItems: null,
            popupItems: null,
            canCheck: false,
            itemWidth: 31,
            itemHeight: 31,
            itemHorMargin: 3,
            popupMaxColumns: 5,
            width: 100,
            terceraButtonStyle: TerceraButton.TerceraButtonStyle.BorderLess
        };
    }
});

TerceraToolStrip.prototype.getType = function () { return 'TerceraToolStrip' };

TerceraToolStrip.prototype.oninit = function ()
{
    ContainerControl.prototype.oninit.apply(this);
    this.onPopupButtonClick = this.onPopupButtonClick.bind(this);
    this.populateItems = this.populateItems.bind(this);
    this.observe('toolStipItems width', this.populateItems, { init: false });
};

TerceraToolStrip.prototype.populateItems = function ()
{
    this.set('popupItems', null);
    // this.removeAllControls({ toolStipElements: true });

    var items = this.get('toolStipItems') || [];//TerceraToolStrip.filterVisibleItems();
    if (!items.length) return;

    var canCheck = this.get('canCheck');
    var terceraButtonStyle = this.get('terceraButtonStyle');

    var controlMargin = this.get('itemHorMargin');
    var btnW = this.get('itemWidth');
    var btnH = this.get('itemHeight')

    var popupBtnW = 14;
    var separatorW = 2;
    var popupW = popupBtnW + separatorW;

    var tsW = this.get('width');

    var availableControlsW = tsW;
    var needShowPopupBtn = TerceraToolStrip.needShowPopupBtn(items, tsW, separatorW, btnW, controlMargin);
    if (needShowPopupBtn) availableControlsW = tsW - popupW;

    var newPopupItems = [];

    var len = items.length;
    var curControlLeft = 0;
    let needCreate = Object.keys(this.Controls).length < 2
    for (var i = 0; i < len; i++)
    {
        var item = items[i];
        var isSeparator = TerceraToolStrip.isSeparator(item);
        var controlW = isSeparator ? separatorW : btnW;
        let itemvisible = item.visible;
        var curControlRight = curControlLeft + controlW;
        if (needCreate)
        {
            var controlToAdd = isSeparator ?
                this.createSeparator(i) :
                TerceraToolStrip.createButton(item, btnW, btnH, terceraButtonStyle, canCheck);

            controlToAdd.setLocation(curControlLeft, 0);
            this.addControl(controlToAdd);
        }
        if (curControlRight > availableControlsW)
        {
            if (!isSeparator && itemvisible)
                newPopupItems.push(item);
            itemvisible = false
        }

        if (this.Controls[item.name])
            this.Controls[item.name].set({ visible: itemvisible, checked: item.active })

        if (i === len - 1)
        {
            if (this.Controls[i - 1])
                this.Controls[i - 1].set({ visible: itemvisible })
        }

        curControlLeft = curControlRight + controlMargin;
    }

    if (needShowPopupBtn)
    {
        var popupBtnLeft = tsW - popupBtnW;

        var popupBtn = this.Controls["popupBtn"]
        if (!popupBtn)
        {
            popupBtn = this.createPopupButton();
            popupBtn.set({ name: "popupBtn" })
            this.addControl(popupBtn);
        }

        popupBtn.setLocation(popupBtnLeft, 2);

        var separator = this.Controls["popupSeparator"]
        if (!separator)
        {
            separator = this.createSeparator();
            separator.set({ name: "popupSeparator" })
            this.addControl(separator);
        }
        separator.setLocation(popupBtnLeft - separatorW, 0);

        popupBtn.set({ visible: true })
        separator.set({ visible: true })
    }
    else if (this.Controls["popupBtn"])
    {
        this.Controls["popupBtn"].set({ visible: false })
        this.Controls["popupSeparator"].set({ visible: false })
    }

    this.set('popupItems', newPopupItems);
};

TerceraToolStrip.prototype.createSeparator = function (indexName)
{
    var sep = new TerceraSeparator();
    if (indexName !== undefined)
        sep.set({ name: indexName });
    sep.set({ isVertical: true, height: this.get('itemHeight') });
    return sep;
};

TerceraToolStrip.createButton = function (curItem, itemW, itemH, terceraButtonStyle, canCheck)
{
    var btn = new TerceraButton();

    btn.set({
        terceraButtonStyle: terceraButtonStyle,
        noBoundBtnClass: curItem.style,
        image: curItem.image,
        name: curItem.name,
        tooltip: curItem.tooltip,
        width: itemW,
        height: itemH,
        canCheck: curItem.canCheck === undefined ? canCheck : curItem.canCheck,
        checked: curItem.active,
        enabled: curItem.enabled,
        imageChecked: curItem.imageChecked
    });

    if (curItem.event)
    {
        btn.on(
            TerceraButton.Events.onClick,
            curItem.event.bind(curItem, curItem.type));
    }

    return btn;
};

TerceraToolStrip.prototype.createPopupButton = function ()
{
    var btn = new TerceraButton();
    btn.set({
        noBoundBtnClass: 'js-more-button',
        terceraButtonStyle: TerceraButton.TerceraButtonStyle.BorderLess,
        width: 14,
        height: this.get('itemHeight')
    });
    btn.on(TerceraButton.Events.onClick, this.onPopupButtonClick);
    return btn;
};

TerceraToolStrip.prototype.onPopupButtonClick = function (popupBtn)
{
    TerceraButtonsPopup.show(
        this.get('popupItems'),
        popupBtn.getX(),
        popupBtn.getY() + this.get('itemHeight'),
        this.get('popupMaxColumns'),
        this.get('itemWidth'),
        this.get('itemHeight'),
        this.get('terceraButtonStyle'),
        this.get('canCheck'));
};

TerceraToolStrip.needShowPopupBtn = function (items, availableWidth, separatorW, btnW, controlMargin)
{
    if (!items || !items.length)
        return false;

    var curControlRight = 0;
    var len = items.length;
    for (var i = 0; i < len; i++)
    {
        var item = items[i];
        var isSeparator = TerceraToolStrip.isSeparator(item);

        curControlRight += isSeparator ? separatorW : btnW;

        if (curControlRight > availableWidth)
            return true;

        curControlRight += controlMargin;
    }

    return false;
};

// TODO. Common method for TerceraToolStrip and TerceraMenu.
TerceraToolStrip.isSeparator = function (item)
{
    return item && item.name === 'separator';
};

// TODO. Common method for TerceraToolStrip and TerceraMenu.
TerceraToolStrip.filterVisibleItems = function (items)
{
    var resItems = [];
    if (!items) return resItems;

    // Filtering visible items.
    var separatorToAdd = null;
    var len = items.length;
    for (var i = 0; i < len; i++)
    {
        var item = items[i];

        if (TerceraToolStrip.isSeparator(item))
        {
            separatorToAdd = item;
            continue;
        }

        if (!item.visible)
            continue;

        if (separatorToAdd)
        {
            resItems.push(separatorToAdd);
            separatorToAdd = null;
        }

        resItems.push(item);
    }

    return resItems;
};

TerceraToolStrip.prototype.getClientPanel = function ()
{
    return this.Controls.toolStipElements.getClientPanel();
}

// TODO. Remove all references.
TerceraToolStrip.prototype.localize = function () { };